export function resolveModelContext(): WebMCP.ModelContext | undefined {
  return (
    (typeof document === 'undefined' ? undefined : document.modelContext) ??
    (typeof navigator === 'undefined' ? undefined : navigator.modelContext)
  );
}
